import downloadTextFile from './downloadTextFile';

/**
 * @typedef CsvColumn
 * @property {string} key
 * @property {string} label
 * @property {(raw: any) => string} [serialize]
 */

/**
 * @param {string} fileName
 * @param {CsvColumn[]} columns
 * @param {{ [key: string]: string }[]} rows
 */
export default function downloadCsv(fileName, columns, rows) {
    const text = [
        // Write headers
        columns.map(c => c.label).join(),

        // Write entries
        ...rows.map(entry => (
            // Write stringified values, joined by commas
            columns.map(({ key, serialize }) => {
                let value = entry[key];

                // If serializer given, use it on the value
                if (serialize) {
                    value = serialize(value);
                }

                // For null/undefined, use empty string
                value = value ?? '';

                // Wrap in quotes
                return `"${value}"`;
            }).join()
        ))
    ].join('\r\n'); // CRLF line-endings required

    downloadTextFile(fileName, text, { type: 'text/csv' });
}